import styled from 'styled-components';

export const prefixCls = 'ui-descriptions';
export const itemCls = `${prefixCls}-item`;
export const labelCls = `${itemCls}-label`;
export const iconCls = `${itemCls}-icon`;
export const prefixCCls = `${itemCls}-prefix`;

export const descriptionsClasses = {
  component: prefixCls,

  item: itemCls,
  itemLeft: `${itemCls}-left`,
  itemRight: `${itemCls}-right`,
  itemHorizontal: `${itemCls}-horizontal`,
  itemVertical: `${itemCls}-vertical`,
  itemInner: `${itemCls}-inner`,

  labelItem: labelCls,
  labelItemIcon: `${labelCls}-icon`,

  iconItem: iconCls,

  prefixItem: prefixCCls,
} as const;

export const Row = styled.tr`
  &,
  .${descriptionsClasses.itemRight} {
    width: 100%;
  }

  &.${descriptionsClasses.itemHorizontal} {
    .${descriptionsClasses.itemLeft} {
      padding-bottom: 8px;
      padding-right: 24px;
    }

    .${descriptionsClasses.itemRight} {
      padding-bottom: 8px;
    }

    &:last-child {
      .${descriptionsClasses.itemLeft}, .${descriptionsClasses.itemRight} {
        padding-bottom: 0;
      }
    }
  }

  &.${descriptionsClasses.itemVertical} {
    .${descriptionsClasses.itemRight} {
      padding-bottom: 8px;
    }

    &:last-child {
      .${descriptionsClasses.itemRight} {
        padding-bottom: 0;
      }
    }
  }

  .${descriptionsClasses.labelItem} {
    display: flex;
    align-items: center;

    color: ${({ theme }) => theme.color.tint.secondary};
    ${({ theme }) => theme.mappedTypography.body1.default};

    .${descriptionsClasses.labelItemIcon} {
      margin-left: 8px;
    }
  }

  .${descriptionsClasses.component}-on-light & {
    .${descriptionsClasses.prefixItem} {
      color: ${({ theme }) => theme.color.tint.primary};
    }

    .${descriptionsClasses.itemRight} {
      color: ${({ theme }) => theme.color.tint.secondary};
    }
  }

  .${descriptionsClasses.component}-on-dark & {
    .${descriptionsClasses.prefixItem} {
      color: ${({ theme }) => theme.color.tint.primaryDark};
    }

    .${descriptionsClasses.itemRight} {
      color: ${({ theme }) => theme.color.tint.secondaryDark};
    }
  }

  .${descriptionsClasses.prefixItem} {
    ${({ theme }) => theme.mappedTypography.body1.strong};
  }
`;

export default styled.table`
  width: 100%;
  overflow-x: auto;
  table-layout: auto;
  border-collapse: collapse;
`;
